import { Fragment } from "react";
import { CheckCircle } from "react-feather";
import { Modal, ModalBody } from "reactstrap";
import { Btn, H3 } from "../../AbstractElements";
import { AddTask, NewTask } from "../../Constant";
import { useAppDispatch, useAppSelector } from "../../Redux-Toolkit/Hooks";
import { setAddModal } from "../../Redux-Toolkit/Reducers/TaskSlice";
import { NewTaskModalForm } from "./NewTaskModalForm";

const NewTaskClass = () => {
  const { addModal } = useAppSelector((state) => state.task);
  const dispatch = useAppDispatch();
  const addToggle = () => dispatch(setAddModal());

  return (
    <Fragment>
      <Btn color="primary" className="badge-light btn-block btn-mail w-100" onClick={addToggle}>
        <CheckCircle className="me-2" />{NewTask}
      </Btn>
      <Modal size="lg" isOpen={addModal} toggle={addToggle}>
        <div className="modal-header">
          <H3 className="modal-title">{AddTask}</H3>
          <Btn color="transprant" className="btn-close" onClick={addToggle} />
        </div>
        <ModalBody>
          <NewTaskModalForm />
        </ModalBody>
      </Modal>
    </Fragment>
  );
};
export default NewTaskClass;
